export default __webpack_public_path__ + "static/media/Gilroy-Bold.bf181b07.ttf";